export default function Table(el) {
  el.outerHTML = `<div class='table-wrap'>${el.outerHTML}</div>`;
}
